import { render, staticRenderFns } from "./PrestacaoContasFinalLancamentoForm.vue?vue&type=template&id=28e5858b&"
import script from "./PrestacaoContasFinalLancamentoForm.vue?vue&type=script&lang=js&"
export * from "./PrestacaoContasFinalLancamentoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports